function Swipe(elem, callback) {
  var self = this;
  this.callback = callback;

  function handleEvent(e) {
    self.touchHandler(e);
  }

  elem.addEventListener("touchstart", handleEvent, false);
  elem.addEventListener("touchmove", handleEvent, false);
  elem.addEventListener("touchend", handleEvent, false);
}

Swipe.prototype.touches = {
  touchstart: { x: -1, y: -1 },
  touchmove: { x: -1, y: -1 },
  touchend: false,
  direction: "undetermined",
};

Swipe.prototype.touchHandler = function (event) {
  var touch;
  if (typeof event !== "undefined") {
    if (typeof event.touches !== "undefined") {
      touch = event.touches[0];
      switch (event.type) {
        case "touchstart":
        case "touchmove":
          this.touches[event.type].x = touch.pageX;
          this.touches[event.type].y = touch.pageY;
          break;
        case "touchend":
          this.touches[event.type] = true;
          var x = this.touches.touchstart.x - this.touches.touchmove.x,
            y = this.touches.touchstart.y - this.touches.touchmove.y;
          if (x < 0) x /= -1;
          if (y < 0) y /= -1;
          if (x > y)
            this.touches.direction =
              this.touches.touchstart.x < this.touches.touchmove.x
                ? "right"
                : "left";
          else
            this.touches.direction =
              this.touches.touchstart.y < this.touches.touchmove.y
                ? "down"
                : "up";
          this.callback(event, this.touches.direction);
          break;
      }
    }
  }
};

export default class Lightbox {
  constructor({
    lazyload = true,
    counter = true,
    arrows = true,
    slideSpeed = 400,
    ...options
  }) {
    if (!options.selector) {
      console.error(
        'Please add a valid css selector with the option "selector:"'
      );
    } else if (typeof options.selector !== "string") {
      console.error(
        options.selector,
        `is not a string but a(n) ${typeof options.selector}`
      );
    } else {
      this.selector = options.selector;
      this.lazyload = lazyload;
      this.counter = counter;
      this.arrows = arrows;
      this.slideSpeed = slideSpeed;

      this.links = Array.from(
        document.querySelectorAll(`a${options.selector}`)
      );
      this.offsets = [];
      this.nodes = {};
      this.imageIndex = null;
      if (this.links.length > 0) {
        this.createLightbox();
        this.createNodes();
        this.eventListeners(this.links);
      } else {
        console.error(
          `The selector '${this.selector}' did not yield results. Please make sure the selector is applied on an 'a' element.`
        );
      }
    }
  }

  goTo = (num, event) => {
    const { items, counter, lightboxNode } = this.nodes;
    if (this.counter) {
      counter.innerHTML = `${num + 1}/${this.links.length}`;
    }
    const spinner = `<div class="spinner"></div>`;
    const img = items[num].querySelector("img");
    // if (this.lazyload) {
    //   const src = img.getAttribute("data-src");
    //   items[num].insertAdjacentHTML("beforeend", spinner);
    //   // Set image attribute
    //   img.setAttribute("src", src);

    //   // Add class to slide item when image is completely loaded. Must be in this order.
    //   const imgLoad = new Image();
    //   imgLoad.onload = () => {
    //     items[num].classList.add("is-active");
    //     items[num].classList.add("is-loaded");
    //   };
    //   imgLoad.src = src;
    // } else {
    //   items[num].classList.add("is-active");
    //   items[num].classList.add("is-loaded");
    // }
    items[num].classList.add("is-active");
    items[num].classList.add("is-loaded");

    // Change the offset for each slide based on its index and the current index.
    for (let i = 0; i < this.offsets.length; i++) {
      const offset = this.offsets[i] - num * 100;

      items[i].style.transform = `translateX(${offset}vw)`;

      // Add transition type based on which event was triggered
      if (event) {
        if (event.target.className === "js-gallery-thumb") {
          items[i].style.transition = `opacity 0.4s ease`;
        } else {
          items[i].style.transition = `transform ${this.slideSpeed}ms ease-out`;
        }
      }
    }
  };

  createNodes = (links) => {
    // Find all the lightbox nodes and add them to an object
    Object.assign(this.nodes, {
      lightboxNode: document.querySelector(".js-gallery"),
      items: Array.from(document.querySelectorAll(".js-gallery-slide")),
      next: document.querySelector(".js-gallery-next"),
      prev: document.querySelector(".js-gallery-prev"),
      close: document.querySelector(".js-gallery-close"),
    });

    Object.assign(this.nodes, {
      counter: document.querySelector(".js-gallery-counter"),
    });
  };

  eventListeners = (links) => {
    const { lightboxNode, items, next, prev, close } = this.nodes;
    links.forEach((item, index) => {
      item.addEventListener("click", (e) => {
        e.preventDefault();
        lightboxNode.classList.add("is-active");
        document.body.style.overflow = "hidden";
        this.imageIndex = index;
        this.goTo(index, e);
        this.setNav(index);
      });
    });

    next.addEventListener("click", (e) => {
      this.goToNext(e);
    });

    prev.addEventListener("click", (e) => {
      this.goToPrev(e);
    });

    close.addEventListener("click", () => {
      this.closeBox();
    });

    document.onkeydown = (e) => {
      switch (e.keyCode) {
        case 37:
          this.goToPrev(e);
          break;
        case 39:
          this.goToNext(e);
          break;
        case 27:
          this.closeBox();
          break;
      }
    };

    items.forEach((item) => {
      // https://gist.github.com/Tam/d44c87b3daeb07b15984ddc6127d4e34
      new Swipe(item.querySelector("img"), (e, direction) => {
        e.preventDefault();
        switch (direction) {
          case "up":
            // Handle Swipe Up
            break;
          case "down":
            // Handle Swipe Down
            break;
          case "left":
            this.goToNext(e);
            break;
          case "right":
            this.goToPrev(e);
            break;
        }
      });
    });
  };

  setNav = (index) => {
    if (this.arrows) {
      const { next, prev } = this.nodes;
      if (index < this.links.length - 1) {
        next.classList.add("is-active");
      }
      // if (index >= this.links.length - 1) {
      //   next.classList.remove("is-active");
      // }
      if (index > 0) {
        prev.classList.add("is-active");
      }
      if (index <= 0) {
        prev.classList.remove("is-active");
      }
    }
  };

  goToNext = (e) => {
    const { items } = this.nodes;
    if (this.imageIndex < items.length - 1) {
      this.goTo(this.imageIndex + 1, e);
      setTimeout(() => {
        items[this.imageIndex - 1].classList.remove("is-active");
      }, this.slideSpeed);
      this.imageIndex += 1;
      this.setNav(this.imageIndex);
    } else {
      this.goTo(0, e);
      setTimeout(() => {
        items[items.length - 1].classList.remove("is-active");
      }, this.slideSpeed);
      this.imageIndex = 0;
      this.setNav(this.imageIndex);
    }
  };

  goToPrev = (e) => {
    const { items } = this.nodes;
    if (this.imageIndex > 0) {
      this.goTo(this.imageIndex - 1, e);
      setTimeout(() => {
        items[this.imageIndex + 1].classList.remove("is-active");
      }, this.slideSpeed);
      this.imageIndex -= 1;
      this.setNav(this.imageIndex);
    }
  };

  closeBox = () => {
    const { lightboxNode, items } = this.nodes;
    lightboxNode.classList.remove("is-active");
    document.body.style.overflow = "auto";
    setTimeout(() => {
      items.forEach((item) => item.classList.remove("is-active"));
    }, this.slideSpeed);
  };

  renderImages = (images) => {
    const imagesLinks = images.map((item, index) => {
      const offset = index * 100;
      this.offsets.push(offset);
      const caption = item.getAttribute("data-caption");
      const imageSrcset = item.getAttribute("data-srcset");
      const imageSrc = item.getAttribute("data-src");
      return `
                <li class='c-gallery__slide js-gallery-slide' style='transform: translateX(${offset}vw)'>
                    ${
                      this.lazyload
                        ? `
                        <img src='${imageSrc}' srcset='data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==' data-srcset='${imageSrcset}' data-sizes='auto' class='lazyload' /> 
                    `
                        : `
                        <img src='${imageSrc}'/>
                    `
                    }
                    <figcaption class="t-small"><span>${caption}</span></figcaption>
                </li>
            `;
    });
    return imagesLinks;
  };

  createLightbox = () => {
    const lightbox = `
            <div class='c-gallery js-gallery'>
                <div class='c-gallery__controls t-small'>
                    <button class="c-gallery-close t-link js-gallery-close">Close</button>
                    <button class="c-gallery-arrow-area prev u-has-glyph u-has-glyph--left js-gallery-prev"></button>
                    <button class="c-gallery-arrow-area next u-has-glyph u-has-glyph--right js-gallery-next"></button>
                    <div class="c-gallery-title"> ${
                      document.querySelector(".js-project-title").innerHTML
                    } </div>
                </div>
                <ul class='c-gallery__slider'>
                    ${this.renderImages(this.links).join("")}
                </ul>
                <div class='c-gallery__counter t-small js-gallery-counter'>
                </div>
            </div>
        `;
    document.querySelector("#main").insertAdjacentHTML("afterend", lightbox);

  };
}
